export enum EventType {
    OPEN_NEW_CATEGORY_POPUP,
    CLOSE_NEW_CATEGORY_POPUP,
    ERROR_NEW_CATEGORY_POPUP_ALREADY_EXISTS,
    ERROR_NEW_CATEGORY_POPUP_GENERIC_ERROR,
    CLOSE_CATEGORY_POPUP,
    ERROR_UPDATE_CATEGORY_POPUP_ALREADY_EXISTS,
    ERROR_UPDATE_CATEGORY_POPUP_GENERIC_ERROR,
    ERROR_COPY_CATEGORY,
    IMAGE_CROP_FINISHED,
    CLOSE_PRODUCT_POPUP
}